// extracted by mini-css-extract-plugin
export default {"table-wrap":"AddControlsTable_table-wrap__rhjya","search":"AddControlsTable_search__t3Y2o","row":"AddControlsTable_row__j7S5D"};